<div class="dashboardNewContentContainer cx-one-ui h-100 hideDoubleScroller">
    <div class="projectionHeader">
        <div class="projection-wrapper">
            <div class="play-pause-icons">
                <button type="button" class="icon-btn" (click)="previousDashboard()" aria-label="Previous Dashboard"
                    cvLocalizedAttrs="aria-label" langSection="Dashboard_Projection" langKey="Previous_Dashboard"
                    [disabled]="settings?.selectedDashboards?.length <= 1 || isSettingsOpen">
                    <svg class="icon-20 fill-iconWhite">
                        <use href="../App_Themes/CXone/icons/arrow-left.svg#arrow-left"></use>
                    </svg>
                </button>
                <button type="button" class="icon-btn" *ngIf="!isPlaying" (click)="startPlaying()" aria-label="Start Playing Projection"
                    cvLocalizedAttrs="aria-label" langSection="Dashboard_Projection" langKey="Start_Playing_Projection"
                    [disabled]="settings?.selectedDashboards?.length <= 1 || isSettingsOpen">
                    <svg class="icon-20 fill-iconWhite">
                        <use href="../App_Themes/CXone/icons/play.svg#play"></use>
                    </svg>
                </button>
                <button type="button" class="icon-btn" *ngIf="isPlaying" (click)="stopPlaying()" aria-label="Stop Playing Projection"
                    cvLocalizedAttrs="aria-label" langSection="Dashboard_Projection" langKey="Stop_Playing_Projection"
                    [disabled]="settings?.selectedDashboards?.length <= 1 || isSettingsOpen">
                    <svg class="icon-20 fill-iconWhite">
                        <use href="../App_Themes/CXone/icons/pause.svg#pause"></use>
                    </svg>
                </button>
                <button type="button" class="icon-btn" (click)="nextDashboard()" aria-label="Next Dashboard"
                    cvLocalizedAttrs="aria-label" langSection="Dashboard_Projection" langKey="Next_Dashboard"
                    [disabled]="settings?.selectedDashboards?.length <= 1 || isSettingsOpen">
                    <svg class="icon-20 fill-iconWhite">
                        <use href="../App_Themes/CXone/icons/arrow-right.svg#arrow-right"></use>
                    </svg>
                </button>
            </div>
            <div class="dashboard-icon">
                <svg class="icon-40">
                    <use href="../App_Themes/CXone/icons/dashboard.svg#dashboard"></use>
                </svg>
                <span class="dashboardName">
                    {{dashboardName}}
                </span>
            </div>
            <div class="settings-icon">
                <span class="dashboardTime">{{dashboardTime | date: 'EEEE, MMM d, y, h:mm a'}}</span>
                <button type="button" [disabled]="isLoading || isSettingsOpen" class="icon-btn fill-valyrianSteel" (click)="openSettingsModal()" aria-label="Settings">
                    <svg class="icon-24 fill-iconWhite"><use href="../App_Themes/CXone/icons/settings.svg#settings"></use></svg>
                </button>
            </div>
        </div>
    </div>    

    <div [hidden]="!isLoading && !isSaving" style="height: 75vh;">
        <cv-loader [size]="'large'" [overlay]="true"></cv-loader>
    </div>

    <cv-responsive-dashboard 
        class="responsiveDashboard" 
        *ngIf="hasInitialized && !isLoading && !isSettingsOpen && dashboard !== null && dashboard.DashboardKey !== null"
        [dashboardInfo]="dashboard"
        [reinitializeOnChanges]="true"
        [iscxonedashboard]="true"
    ></cv-responsive-dashboard>
    <div class="empty-workspace-container" *ngIf="dashboard === null || dashboard.DashboardKey === null" [hidden]="isLoading || isSettingsOpen">
        <svg class="mb-1">
            <use href="../App_Themes/CXone/icons/add-dashboard.svg#add-dashboard"></use>
        </svg>
        <div class="empty-workspace-message" cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'No_Dashboards'">No dashboards selected</div>
    </div>
</div>

<ng-template #projectionSettingsModal let-modal class="cx-one-ui">
    <div data-qa="cxone-dashboard-projections-project-dashboard-modal">
        <div class="modal-header">
            <div class="modal-title" cvLocalizedText langSection="Dashboard_Projection" langKey="Project_Dashboard">Project Dashboard</div>
            <button type="button" class="modal-close icon-btn fill-iconDefault" (click)="cancelProjectionSettings();" [disabled]="isSaving">
                <svg class="icon-12">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <div class="large-error-container" *ngIf="noData">
                <svg class="load-error-icon"><use href="../App_Themes/CXone/icons/data-error.svg#data-error"></use></svg>
                    <div class="cxone-error-text" cvLocalizedText [langSection]="'Error_Module'" [langKey]="'CXOne_Load_Data_Message'">
                        There was an error while trying to load the widget's data
                    </div>
            </div>
            <div class="large-error-container" *ngIf="noAccess">
                <svg class="permission-error-icon"><use href="../App_Themes/CXone/icons/no-permission.svg#no-permission"></use></svg>
                    <div class="cxone-error-text" cvLocalizedText [langSection]="'Error_Module'" [langKey]="'CXOne_Access_Denied_Message'">
                        You do not have the permissions required for this widget
                    </div>
            </div>
        <div *ngIf="!noData || !noAccess">
            <div class="content-container">
                <!-- Available list -->
                <div class="w-50">
                    <div class="header-container">
                        <div class="tab-group">
                            <div class="tabs-container w-100">
                            <div class="icon-btn radio-based left-header" ngbRadioGroup name="dashboardType">
                                <!-- Tabs -->
                                <div class="bodyRow">
                                    <div class="tab d-flex align-items-center">
                                        <a [ngClass]="{ 'active': favoriteOpen }" class="d-flex justify-content-center" tabindex="0" (click)="openFavorites()">
                                            <svg class="icon-16 fill-favoriteYellow mb-1" style="margin-right: 10px;" *ngIf="favoriteOpen">
                                                <use href="../App_Themes/CXone/icons/favorite-star.svg#favorite-star"></use>
                                            </svg>
                                            <svg class="icon-16 fill-iconOutline mb-1" style="margin-right: 10px;" *ngIf="!favoriteOpen">
                                                <use href="../App_Themes/CXone/icons/favorite-star-outline.svg#favorite-star-outline"></use>
                                            </svg>
                                            <span cvLocalizedText langSection="Dashboard_Projection" langKey="Favorites">Favorites</span>
                                        </a>
                                        <a [ngClass]="{ 'active': dashboardOpen }" (click)="openDashboards()" tabindex="0" 
                                            cvLocalizedText langSection="Dashboard_Projection" langKey="All">
                                            All
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="cxone-live-search right-header">
                                <cxone-text-input 
                                    class="search-box live-search"
                                    placeholder="{{placeholder}}" 
                                    [(ngModel)]="searchTerm" 
                                    (keyup)="filterAvailableDashboards()"
                                    (ngModelChangeDebounced)="searchTerm" 
                                    [ngModelChangeDebounceTime]="200">
                                </cxone-text-input>
                                <i class="cxone-search-icon" [hidden]="searchTerm.length !== 0">
                                    <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                                        <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                                    </svg>
                                </i>
                                <i [hidden]="searchTerm.length === 0" (click)="clearFilter()">
                                    <svg class="icon-18 fill-iconDefault cxone-close-wrapper">
                                        <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                                    </svg>
                                </i>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="selected-table">
                        <div class="overflow-auto" *ngIf="filteredDashboardsOnModal.length > 0">
                            <button *ngFor="let dashboard of filteredDashboardsOnModal || []" class="dashboard-item text-left w-100" (click)="selectDashboardForProjection(dashboard)"
                                    [attr.aria-label]="dashboard.DashboardName + '. ' + dashboard.DashboardDescription">
                                <div class="dashboard-selection-container">
                                    <div class="dashboard-name">{{dashboard.DashboardName}}</div>
                                    <div class="dashboard-description text-truncate">{{dashboard.DashboardDescription}}</div>
                                </div>
                            </button>
                        </div>
                        <div class="error-table" *ngIf="filteredDashboardsOnModal.length === 0">
                            <div class="error-container">
                                <div class="d-flex emptyTableIcon">
                                    <svg class="empty-error-icon">
                                        <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
                                    </svg>
                                </div>
                                <span class="cxone-error-text" cvLocalizedText langSection="Dashboard_Projection" langKey="No_Dashboards">No dashboards</span>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- Selected list -->
                <div class="w-50">
                    <div class="header-container">
                        <div class="tab-group">
                            <div class="selected-container">
                                <div class="selected-text" >
                                    <span cvLocalizedText langSection="Dashboard_Projection" langKey="Selected" tabindex="0">Selected</span>
                                    <span> ({{this.settings.temp.selectedDashboards.length || 0}})</span>
                                </div> <!--CountHeaderLocation-->
                                <div class="">
                                    <button type="button" [disabled]="this.settings.temp.selectedDashboards.length < 1" class="btn btn-text" (click)="removeAllDashboardsFromProjection()"
                                        cvLocalizedText langSection="Dashboard_Projection" langKey="Remove_All">Remove All</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="error-table" *ngIf="this.settings.temp.selectedDashboards.length === 0">
                        <div class="error-container">
                            <div class="d-flex emptyTableIcon">
                                <svg class="empty-error-icon">
                                    <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
                                </svg>
                            </div>
                            <span class="cxone-error-text" cvLocalizedText langSection="CXOne_Dashboard" langKey="No_Dashboards">No dashboards selected</span>
                        </div>
                    </div>
                    <div class="selected-table" *ngIf="this.settings?.temp?.selectedDashboards?.length > 0">
                        <div class="overflow-auto">
                            <div *ngFor="let dashboard of settings?.temp?.selectedDashboardObjects || []" class="dashboard-item">
                                <div class="dashboard-selection-container">
                                    <div class="dashboard-name">{{dashboard.DashboardName}}</div>
                                    <div class="dashboard-description text-truncate">{{dashboard.DashboardDescription}}</div>
                                </div>
                                <div class="">
                                    <button type="button" class="icon-btn fill-iconDefault" (click)="removeDashboardFromProjection(dashboard)"
                                        [attr.aria-label]="getDashboardRemoveAriaLabel(dashboard.DashboardName)">
                                        <svg class="icon-10 fill-iconDefault">
                                            <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <div class="time-selection cx-one-ui cxone-checkbox">
                        <cxone-checkbox 
                            class="cxone-checkbox"
                            type="checkbox" 
                            checkboxId="defaultCheck1" 
                            [(ngModel)]="settings.temp.useAutoSwipe" 
                            (ngModelChange)="handleAutoSwipeChanged()">
                        </cxone-checkbox>
                        <span style="margin-left: -8px;">{{ autoSwipeLabel1 }}</span>
    
                            <div class="time-inputs py-2">
                                <!-- <input type="text" class="form-control swipeControl" [disabled]="!settings.temp.useAutoSwipe" [(ngModel)]="settings.temp.autoSwipeDelay" appTimeEntry />                 -->
                                <input
                                    id="minutes-input"
                                    type="number"
                                    class="form-control swipeControl"
                                    [defaultValue]="defaultSwipeMinutes"
                                    maxlength="2"
                                    min="0" 
                                    aria-label="Minutes"
                                    [(ngModel)]="settings.temp.rawMinutesInput"
                                    #minutesInput
                                    (focus)="minutesInput.select();"
                                    (input)="validateMinutesInput($event);"
                                    (blur)="handleMinutesBlur($event);" 
                                />
                                <span class="mt-2 mx-1" [ngClass]="{'text-disabled': !settings.temp.useAutoSwipe}">:</span>
                                <input 
                                    id="seconds-input" 
                                    type="number" 
                                    class="form-control swipeControl" 
                                    [defaultValue]="defaultSwipeSeconds"
                                    aria-label="Seconds"
                                    [(ngModel)]="settings.temp.rawSecondsInput" 
                                    #secondsInput 
                                    (focus)="secondsInput.select();" 
                                    (input)="validateSecondsInput($event);"
                                    (blur)="handleSecondsBlur($event);"
                                />
                            </div>
                            <div>{{ autoSwipeLabel2 }}</div>
                </div> 
                <span class="invalid-feedback d-flex validation-footer" *ngIf="!validationErrors.swipeTime.showing"></span>
                <span *ngIf="validationErrors.swipeTime.showing" tabindex="0" class="invalid-feedback d-flex validation-footer">
                    {{validationErrors.swipeTime.message}}
                </span>  
            </div>  
        </div>
    
        <div class="modal-footer">
            <div *ngIf="noData || noAccess">
                <button type="button" class="btn btn-secondary modal-footer-btn" (click)="cancelProjectionSettings();" 
                cvLocalizedText langSection="Common" langKey="Close_Button">Close</button>
            </div>
            <div *ngIf="!noData || !noAccess">
            <button type="button" class="btn btn-secondary modal-footer-btn mr-2" (click)="cancelProjectionSettings();" 
                cvLocalizedText langSection="Common" langKey="Cancel_Button" [disabled]="isSaving">Cancel</button>
            <button type="button" class="btn btn-primary modal-footer-btn" [disabled]="!settings.savingAllowed || isSaving" (click)="saveProjectionSettings();" 
                cvLocalizedText langSection="Dashboard_Projection" langKey="Project_Button">Project</button>
            </div>
        </div>
    </div>
</ng-template>
